export default __webpack_public_path__ + "static/media/17.b0a7c4e9.mp3";